import { render, staticRenderFns } from "./ObjectivesCreate.vue?vue&type=template&id=b9dbdd26"
import script from "./ObjectivesCreate.vue?vue&type=script&lang=js"
export * from "./ObjectivesCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports